export const CANONICAL_RELAY_ORIGIN = "https://relay.gettheinspirededge.com";

const CANONICAL_RELAY_HOSTNAMES = new Set([
  "relay.gettheinspirededge.com",
  "localhost",
  "127.0.0.1",
  "::1",
  "[::1]",
]);

const PUBLIC_CUSTOM_HOSTNAME_PATHS = [
  /^\/book\/[^/]+\/[^/]+(?:\/[^/]+)?\/?$/,
  /^\/booking\/(?:confirmed|invoiced|cancel|reschedule)\/[^/]+\/?$/,
  /^\/d\/[^/]+\/?$/,
  /^\/f\/[^/]+\/[^/]+\/?$/,
  /^\/portal(?:\/[^/]+)?\/?$/,
  /^\/review\/[^/]+\/?$/,
  /^\/unsubscribe\/?$/,
];

// Relay UAT (relay-uat.<account>.workers.dev, set only by
// deploy-relay-uat.yml) has no fixed hostname to allowlist ahead of time —
// Cloudflare assigns the account subdomain. This flag is never set in the
// committed .env.production, so a production build always falls through to
// the strict allowlist below; only a Relay UAT build trusts its own origin.
function trustsCurrentHostname(): boolean {
  return import.meta.env.VITE_TRUST_CURRENT_HOSTNAME === "true";
}

export function isCanonicalRelayHostname(hostname: string): boolean {
  if (trustsCurrentHostname()) {
    return true;
  }
  return CANONICAL_RELAY_HOSTNAMES.has(hostname.toLowerCase());
}

export function isPublicCustomHostnamePath(pathname: string): boolean {
  return PUBLIC_CUSTOM_HOSTNAME_PATHS.some((pattern) => pattern.test(pathname));
}

export function getCanonicalRelayRedirectUrl(location: Location): string | null {
  if (isCanonicalRelayHostname(location.hostname)) {
    return null;
  }

  if (isPublicCustomHostnamePath(location.pathname)) {
    return null;
  }

  return `${CANONICAL_RELAY_ORIGIN}${location.pathname}${location.search}${location.hash}`;
}

function isSupabaseAuthKey(name: string): boolean {
  return /^sb-.+-auth-token(?:\.\d+)?$/.test(name);
}

export function clearCustomHostnameAuthStorage(storage: Storage, cookieString: string): string[] {
  const expiredCookieHeaders: string[] = [];

  for (let index = storage.length - 1; index >= 0; index -= 1) {
    const key = storage.key(index);
    if (key && isSupabaseAuthKey(key)) {
      storage.removeItem(key);
    }
  }

  for (const cookie of cookieString.split(";")) {
    const name = cookie.split("=", 1)[0]?.trim();
    if (name && isSupabaseAuthKey(name)) {
      expiredCookieHeaders.push(`${name}=; Max-Age=0; path=/; SameSite=Lax`);
    }
  }

  return expiredCookieHeaders;
}
